module.exports = __webpack_public_path__ + "static/media/ExpenseByCategory_Transparent.5303bd85.png";